import { format } from "date-fns";
import { CashLedgerNode } from "../../../build/types";
import { CashLedgerData } from "../../../build/printLayoutTypes";
import "./style.scss";

interface CashLedgerContainerProps {
    node: CashLedgerNode;
    cashLedgerData: CashLedgerData;
    cashLedgerLabels?: string;
    formatCurrency: (amount: number) => string;
}

const CashLedgerLayout = ({ node, cashLedgerData, formatCurrency }: CashLedgerContainerProps) => {
    return (
        <div className="cash-ledger cash-ledger-gap flex-col cash-ledger">
            <p>Z-Report: {cashLedgerData.count}</p>
            <div className="cash-ledger-gap flex-col">
                <p className="cash-ledger-bold">Opening</p>

                {node.settings.showTime ? (
                    <p>Opening Time: {format(cashLedgerData.openingTime, "dd MMMM yyyy, hh:mm aaaa")}</p>
                ) : null}
                <p>Opening Balance:{formatCurrency(cashLedgerData.openingBalance)}</p>
                <p>Opened by: {cashLedgerData.openedBy}</p>
            </div>
            <div className="cash-ledger-gap flex-col">
                <p className="cash-ledger-bold">Closing</p>

                {node.settings.showTime ? (
                    <p>Closing Time: {format(cashLedgerData.closingTime, "dd MMMM yyyy, hh:mm aaaa")}</p>
                ) : null}
                <p>Closing Balance:{formatCurrency(cashLedgerData.closingBalance)}</p>
                <p>Closed by: {cashLedgerData.closedBy}</p>
            </div>
            <hr className="divider" />

            <div className="cash-ledger-gap flex-col">
                <div>
                    <p>Transactions</p>
                    <hr className="divider" />
                </div>
                {cashLedgerData.transactions.map((t, index) => {
                    let label = "";
                    let amountSign = "";

                    switch (t.type) {
                        case "sale":
                            label = `Order ID: ${t.orderId}`;
                            amountSign = "+";
                            break;
                        case "withdrawal":
                            label = "Cash Withdrawal";
                            amountSign = "-";
                            break;
                        case "add":
                            label = "Cash Deposit";
                            amountSign = "+";
                            break;
                        default:
                            return null; // or handle unexpected types if necessary
                    }

                    return (
                        <div className="cash-ledger-gap flex-col" key={`${t.type}-${index}`}>
                            <div className="flex-space">
                                <p className="cash-ledger-bold">{label}</p>
                                <p>{format(t.time, "dd/MM/yyyy-hh.mma")}</p>
                            </div>
                            <div className="transaction-grid">
                                <p>Taxes</p>
                                <p>Amount</p>
                                <p>Balance</p>
                            </div>
                            <div className="transaction-grid">
                                <p>{t.taxRates.join("/")}</p>
                                <p>
                                    {amountSign}
                                    {formatCurrency(t.amount)}
                                </p>
                                <p>{formatCurrency(t.balance)}</p>
                            </div>
                            {t.notes ? <p>{t.notes}</p> : null}
                        </div>
                    );
                })}
                <hr className="divider" />

                <div className="cash-ledger-gap flex-col">
                    <div className="transaction-grid">
                        <p>Opening Balance</p>
                        <p>Added</p>
                        <p>Subtracted</p>
                    </div>
                    <div className="transaction-grid">
                        <p>{formatCurrency(cashLedgerData.openingBalance)}</p>
                        <p>+{formatCurrency(cashLedgerData.added)}</p>
                        <p>-{formatCurrency(cashLedgerData.substracted)}</p>
                    </div>
                    <p className="cash-ledger-bold">Closing Balance: {formatCurrency(cashLedgerData.closingBalance)}</p>
                </div>
            </div>
        </div>
    );
};

export default CashLedgerLayout;
